import React from 'react'
import Card from '../../api/components-examples/ImageCard'
import Group from '../../api/components-examples/ImageCard/Group'
import WaitingLoaders from '../Loaders/WaitingLoaders.jsx'
import { BackNavigation } from '../Back/BackNavigation.js'
import { groupProjects } from '../../api/components-examples/utils/commonUtilityFunctions'

const ProjectsBuild = ({
    openProjectPopup,
    data,
    tabView,
    flowGroups,
    RgroupId,
    fetchAllgroups,
    getIsLocked,
    showAvailable,
    backs,
    checkoutBuildGroup,
    checkoutLearnGroup,
    breadcrumb,
    filteredGroupKeys
}) => {
    const indus = [...new Set(data.map(i => i.industry).flat())]
    const industries = indus.map(l => {
        return { value: l, label: l }
    }, ...[{ value: 'All', label: 'All' }])

    const [selectedOption, setSelectedOption] = React.useState('All')

    const handleChange = selectedOption => {
        setSelectedOption(selectedOption.target.value)
    }

    const groupsInside = groupProjects(data, RgroupId === null ? 'group_id' : 'DONTGROUP', 'noGroup')

    return (
        <>
            <div className="project-flow main-container">
                {indus.length > 0 && (
                    <div>
                        <div className="selected-industry">Industry</div>
                        <div className="select-container">
                            <select className="custom-select" onChange={handleChange}>
                                <option value={'All'}> {'All'}</option>
                                {industries.map(i => {
                                    return <option value={i.value}> {i.label}</option>
                                })}
                            </select>
                        </div>
                    </div>
                )}
            </div>

            <div className="em-flex" style={{ justifyContent: 'end' }}>
                <BackNavigation
                    backs={() => backs()}
                />
            </div>

            <div className={`sample-projects customScrollDsgn ${tabView ? 'scrollHeight-projects' : ''}`}>
                {fetchAllgroups.isLoading ? (
                    <div className="em-row locenter" style={{ height: '200px' }}>
                        <WaitingLoaders show={true} size={90} position='absolute' />
                    </div>
                ) : (
                    <>
                        {data.length === 0 || (typeof flowGroups === 'object' && !Array.isArray(flowGroups) && filteredGroupKeys.length === 0) ? (
                            <div className="em-column locenter" style={{ height: '100%', padding: '40px', textAlign: 'center' }}>
                                <img
                                    src={require('../../images/Inventory Optimization.png')}
                                    style={{ width: '120px', opacity: 0.5, marginBottom: '20px', filter: 'grayscale(1)' }}
                                />
                                <h3 style={{ color: '#888', fontWeight: '500' }}>No Projects Found</h3>
                                <p style={{ color: '#aaa', fontSize: '14px', maxWidth: '300px' }}>
                                    No build flows are currently available for your account. Try exploring the Learn tab or contact support.
                                </p>
                            </div>
                        ) : flowGroups && typeof flowGroups === 'object' && !Array.isArray(flowGroups) && (
                            <>
                                {(() => {
                                    let projects = []
                                    const blank_project = data.find(i => i.flow_id === 'blank_project')
                                    if (RgroupId === null) {
                                        filteredGroupKeys.forEach(key => {
                                            let isPractice = []
                                            if (key === 'default_build' || key === 'default_learn') {
                                                const typeNeeded = key === 'default_learn' ? 'learn' : 'build'
                                                isPractice = (groupsInside['noGroup'] || []).filter(card =>
                                                    (!card.group_id || !flowGroups[card.group_id]) &&
                                                    (card.type === typeNeeded || (typeNeeded === 'learn' ? card.learn === true : card.learn === false)) &&
                                                    (selectedOption === 'All' ? true : card.industry.includes(selectedOption))
                                                )
                                            } else if (key !== undefined && key !== null && key !== 'noGroup' && groupsInside[key]) {
                                                isPractice = groupsInside[key].filter(i =>
                                                    selectedOption === 'All' ? true : i.industry.includes(selectedOption)
                                                )
                                            }

                                            if (isPractice.length > 0) {
                                                projects.push(<Group item={flowGroups[key]} onClick={() => (key === 'default_learn' ? checkoutLearnGroup(key) : checkoutBuildGroup(key))} />)
                                            }
                                        })
                                    } else {
                                        if (groupsInside['noGroup']) {
                                            groupsInside['noGroup']
                                                .filter(card => {
                                                    if (RgroupId === 'default_build' || RgroupId === 'default_learn') {
                                                        const typeNeeded = RgroupId === 'default_learn' ? 'learn' : 'build'
                                                        return (!card.group_id || !flowGroups[card.group_id]) &&
                                                            (card.type === typeNeeded || (typeNeeded === 'learn' ? card.learn === true : card.learn === false))
                                                    }
                                                    // Named group: only show cards that belong to this group
                                                    return card.group_id === RgroupId
                                                })
                                                .filter(i => (selectedOption === 'All' ? true : i.industry.includes(selectedOption)))
                                                .map(card => {
                                                    if (card.flow_id !== 'blank_project') {
                                                        const isLocked = getIsLocked(card)
                                                        if (showAvailable === true && isLocked === true) return
                                                        projects.push(
                                                            <Card
                                                                item={card}
                                                                onClick={() =>
                                                                    openProjectPopup(card.value, card.label, card.flow_id, card.Description, card, true)
                                                                }
                                                                isLocked={isLocked}
                                                            />
                                                        )
                                                    }
                                                })
                                        }
                                    }
                                    if (RgroupId === null && blank_project) {
                                        projects.push(
                                            <Card
                                                item={blank_project}
                                                onClick={() =>
                                                    openProjectPopup(
                                                        blank_project.value,
                                                        null,
                                                        blank_project.flow_id,
                                                        blank_project.Description,
                                                        blank_project,
                                                        true
                                                    )
                                                }
                                                isLocked={false}
                                            />
                                        )
                                    }
                                    return projects.length > 0 ? projects.map(item => item) : (
                                        <div className="em-column locenter" style={{ width: '100%', padding: '40px', textAlign: 'center' }}>
                                            <h3 style={{ color: '#888', fontWeight: '500' }}>No Projects Match This Filter</h3>
                                        </div>
                                    )
                                })()}
                            </>
                        )}
                    </>
                )}
            </div>
        </>
    )
}

export default ProjectsBuild
